import { useEnvValue } from '@morningtrain/react-helpers'

export default function useDepartments () {
  return useEnvValue('globals.departments', [])
}
